/**
 * Shared “app shell” styles for the top bar and the search strip below it.
 * Keep in sync when adjusting primary navigation or global search.
 */
export const APP_SHELL_BAR_STYLES = {
  background: 'linear-gradient(180deg, #1a1d24 0%, #12151a 100%)',
  color: 'rgba(255, 255, 255, 0.92)',
  borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
  boxShadow: '0 1px 0 rgba(0,0,0,0.2), 0 8px 32px rgba(0,0,0,0.12)',
  backdropFilter: 'saturate(180%) blur(8px)',
};

export const APP_SHELL_SEARCH_SX = {
  background: 'linear-gradient(180deg, #181b20 0%, #101318 100%)',
  color: 'rgba(255, 255, 255, 0.92)',
  borderTop: '1px solid rgba(255, 255, 255, 0.06)',
  borderBottom: '1px solid rgba(0, 0, 0, 0.2)',
  boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.04)',
};
